export const pill = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    padding: '5px 11px',   // fix 2 — was 4px 10px → 24px to 30px height
    borderRadius: '999px',
    fontSize: '0.78rem',
    fontWeight: 500,
    cursor: 'pointer',
    border: '1px solid',
    transition: 'all 0.18s ease',
    userSelect: 'none',
    ...(active ? {
        background: 'linear-gradient(90deg, #00D7FF, #0078FF)',
        borderColor: 'transparent',
        color: '#001025',
    } : {
        background: 'rgba(255,255,255,0.05)',
        borderColor: 'rgba(187,188,188,0.18)',
        color: 'var(--ecal-lightgrey)',
        '&:hover': {
            color: 'var(--ecal-white)',
            borderColor: 'rgba(0,215,255,0.6)',
            background: 'rgba(0,120,255,0.12)',
        },
    }),
});
